import { useState, useEffect } from 'react';

function useCountdown() {
  const getTarget = () => {
    // Target: next Sunday 23:59
    const now = new Date();
    const day = now.getDay(); // 0=Sun, 6=Sat
    const daysUntilSunday = day === 0 ? 7 : 7 - day;
    const target = new Date(now);
    target.setDate(now.getDate() + daysUntilSunday);
    target.setHours(23, 59, 59, 0);
    return target;
  };

  const calc = () => {
    const diff = getTarget().getTime() - Date.now();
    if (diff <= 0) return { h: 0, m: 0, s: 0 };
    return {
      h: Math.floor(diff / 3600000),
      m: Math.floor((diff % 3600000) / 60000),
      s: Math.floor((diff % 60000) / 1000),
    };
  };

  const [time, setTime] = useState(calc());
  useEffect(() => {
    const id = setInterval(() => setTime(calc()), 1000);
    return () => clearInterval(id);
  }, []);
  return time;
}

export default function UrgencyBanner() {
  const [visible, setVisible] = useState(true);
  const { h, m, s } = useCountdown();
  if (!visible) return null;

  const pad = (n: number) => String(n).padStart(2, '0');

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-[#07091A] border-b border-neon/30">
      <div className="w-full px-3 md:px-4 py-2 md:py-2.5 flex items-center justify-between gap-2">
        <div className="flex-1 flex items-center justify-center gap-2 md:gap-4 min-w-0 overflow-hidden">
          {/* Live dot */}
          <div className="flex items-center gap-1.5 flex-shrink-0">
            <span className="w-1.5 h-1.5 md:w-2 md:h-2 bg-neon rounded-full animate-pulse inline-block"></span>
            <span className="text-white/50 text-xs font-medium whitespace-nowrap hidden sm:inline">이번 주 무료 진단 마감까지</span>
            <span className="text-white/50 text-xs font-medium whitespace-nowrap sm:hidden">마감</span>
          </div>
          {/* Countdown */}
          <div className="flex items-center gap-1">
            {[{ val: pad(h), unit: '시간' }, { val: pad(m), unit: '분' }, { val: pad(s), unit: '초' }].map((t, i) => (
              <div key={i} className="flex items-center gap-0.5 md:gap-1">
                <span className="bg-neon text-navy font-black text-xs md:text-sm px-1.5 md:px-2 py-0.5 rounded font-display min-w-[1.6rem] md:min-w-[2rem] text-center">{t.val}</span>
                <span className="text-white/35 text-xs hidden md:inline">{t.unit}</span>
                {i < 2 && <span className="text-neon font-black text-xs md:text-sm mx-0.5">:</span>}
              </div>
            ))}
          </div>
          <button
            className="hidden md:block bg-neon text-navy font-black text-xs px-4 py-1.5 rounded-full whitespace-nowrap hover:bg-neon-dim transition-colors cursor-pointer"
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
          >
            지금 무료로 광고 진단 받기 →
          </button>
        </div>
        <button
          className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 flex items-center justify-center text-white/30 hover:text-white/60 cursor-pointer"
          onClick={() => setVisible(false)}
        >
          <i className="ri-close-line text-sm md:text-base"></i>
        </button>
      </div>
    </div>
  );
}
